import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const { Provider, Consumer } = React.createContext<Record<number, any>>({});
export { Provider, Consumer };
